import {request} from "../request.js"

export const entitlementsCreate = async (data, opts) => {
  return request({
    endpoint: "v1/entitlements",
    method: "POST",
    data: {data},
    opts,
  })
}

export const entitlementsBulkCreate = async (data, opts) => {
  return request({
    endpoint: "v1/entitlements/bulk",
    method: "POST",
    data: {data},
    opts,
  })
}

export const entitlementsGet = async (entitlementId, opts) => {
  const params = new URLSearchParams()

  if (opts?.include) {
    params.append("include", Array.isArray(opts.include) ? opts.include.join(",") : opts.include)
  }

  if (opts?.filter) {
    params.append("filter", JSON.stringify(opts.filter))
  }

  const query = params.toString() ? `?${params.toString()}` : ""
  const endpoint = entitlementId
    ? `v1/entitlements/${entitlementId}${query}`
    : `v1/entitlements${query}`
  return request({
    endpoint,
    method: "GET",
    opts,
  })
}

export const entitlementsUpdate = async (entitlementId, data, opts) => {
  return request({
    endpoint: `v1/entitlements/${entitlementId}`,
    method: "PATCH",
    data: {data},
    opts,
  })
}

export const entitlementsFindByCode = async (code, opts) => {
  return request({
    endpoint: `v1/entitlements/?code=${encodeURIComponent(code)}`,
    method: "GET",
    opts,
  })
}

// passes projects endpoints
export const entitlementsPassesProjectsCreate = async (data, opts) => {
  return request({
    endpoint: "v1/entitlements/passes/projects",
    method: "POST",
    data: {data},
    opts,
  })
}

export const entitlementsPassesProjectsGet = async (projectId, opts) => {
  const params = new URLSearchParams()

  if (opts?.include) {
    params.append("include", opts.include)
  }

  if (opts?.filter) {
    params.append("filter", JSON.stringify(opts.filter))
  }

  const query = params.toString() ? `?${params.toString()}` : ""
  const endpoint = projectId
    ? `v1/entitlements/passes/projects/${projectId}${query}`
    : `v1/entitlements/passes/projects${query}`

  return request({
    endpoint,
    method: "GET",
    opts,
  })
}

// passes apple PKI endpoints
export const entitlementsPassesApplePkiCreate = async (data, opts) => {
  return request({
    endpoint: "v1/entitlements/passes/apple-pki",
    method: "POST",
    data: {data},
    opts,
  })
}

export const entitlementsPassesApplePkiGet = async (pkiId, opts) => {
  const params = new URLSearchParams()

  if (opts?.include) {
    params.append("include", opts.include)
  }

  if (opts?.filter) {
    params.append("filter", JSON.stringify(opts.filter))
  }

  const query = params.toString() ? `?${params.toString()}` : ""
  const endpoint = pkiId
    ? `v1/entitlements/passes/apple-pki/${pkiId}${query}`
    : `v1/entitlements/passes/apple-pki${query}`

  return request({
    endpoint,
    method: "GET",
    opts,
  })
}

// passes google issuer id endpoints
export const entitlementsPassesGoogleIssuerIdCreate = async (data, opts) => {
  return request({
    endpoint: "v1/entitlements/passes/google-issuer-id",
    method: "POST",
    data: {data},
    opts,
  })
}

// passes google class endpoints
export const entitlementsPassesGoogleClassCreate = async (data, opts) => {
  return request({
    endpoint: "v1/entitlements/passes/google-class",
    method: "POST",
    data: {data},
    opts,
  })
}

export const entitlementsPassesGoogleClassUpdate = async (data, opts) => {
  return request({
    endpoint: "v1/entitlements/passes/google-class",
    method: "PATCH",
    data: {data},
    opts,
  })
}

// passes issue endpoints
export const entitlementsPassesIssue = async (entitlementId, vendor, opts) => {
  return request({
    endpoint: `v1/entitlements/${entitlementId}/pass/${vendor}`,
    method: "GET",
    opts,
  })
}

// vouchers endpoints
export const entitlementsVouchersGet = async (entitlementId, opts) => {
  return request({
    endpoint: `v1/entitlements/vouchers/${entitlementId}`,
    method: "GET",
    opts,
  })
}

// document PDF endpoints (new template system)
export const entitlementsDocumentPdfGet = async (entitlementId, output = "print", opts) => {
  const params = new URLSearchParams()
  if (output) {
    params.append("output", output)
  }
  const query = params.toString() ? `?${params.toString()}` : ""
  return request({
    endpoint: `v1/entitlements/document-pdf/${entitlementId}${query}`,
    method: "GET",
    opts: {
      ...opts,
      download: true,
    },
  })
}

// voucher templates endpoints
export const entitlementsVoucherTemplatesCreate = async (data, opts) => {
  return request({
    endpoint: "v1/entitlements/voucher-templates",
    method: "POST",
    data: {data},
    opts,
  })
}

export const entitlementsVoucherTemplatesGet = async (templateId, opts) => {
  const params = new URLSearchParams()

  console.log("calling voucher templates get")

  if (opts?.include) {
    params.append("include", opts.include)
  }

  const query = params.toString() ? `?${params.toString()}` : ""
  const endpoint = templateId
    ? `v1/entitlements/voucher-templates/${templateId}${query}`
    : `v1/entitlements/voucher-templates${query}`

  return request({
    endpoint,
    method: "GET",
    opts,
  })
}

export const entitlementsVoucherTemplatesPreviewGet = async (data, opts) => {
  return request({
    endpoint: `v1/entitlements/voucher-templates/preview`,
    method: "POST",
    data: {data},
    opts,
  })
}
